// extracted by mini-css-extract-plugin
module.exports = {"animationShadow":"styles_animationShadow__3ksS_","place-holder-shimmer":"styles_place-holder-shimmer__UksTV"};